import {
  Box,
  Flex,
  Link,
  Modal,
  theme,
  Typography,
} from '@fe-toolkit/web-components/ssr'

import content from '@/content/content'

type WhatsAnEsimModalProps = {
  display: boolean
  setDisplay: (display: boolean) => void
}

const WhatsAnEsimModal = ({ display, setDisplay }: WhatsAnEsimModalProps) => {
  const { whatIsAnEsimModal } = content
  return (
    <Modal
      closeModal={() => setDisplay(false)}
      disableScrolling={true}
      display={display}
      modalBackgroundColour="wildSand"
      setDisplay={setDisplay}
      title={whatIsAnEsimModal.title}
    >
      <Flex
        flexDirection="column"
        gap={theme.spacing.small}
        p={theme.spacing.medium}
      >
        <Typography as={'p'} variant={'speak'}>
          {whatIsAnEsimModal.description}
        </Typography>
        <Box marginTop={theme.spacing.large} textAlign="center">
          <Link as={'button'} onClick={() => setDisplay(false)}>
            {content.modalCloseLinkLabel}
          </Link>
        </Box>
      </Flex>
    </Modal>
  )
}

export default WhatsAnEsimModal
